import { trpc } from "#/lib/trpc/client"
import { HealthieAnswer } from "@internal/telemedicine"
import { useMutation, type UseMutationResult } from "@tanstack/react-query"

type SubmitIntakeFormVariables = { appointmentId: string; formId: string; answers: HealthieAnswer[] }
type SubmitIntakeFormData = Awaited<ReturnType<typeof trpc.telemedicine.submitForm.mutate>>

export function useSubmitIntakeForm(): UseMutationResult<SubmitIntakeFormData, Error, SubmitIntakeFormVariables> {
  return useMutation({
    mutationFn: ({ appointmentId, formId, answers }: SubmitIntakeFormVariables) =>
      trpc.telemedicine.submitForm.mutate({ appointmentId, formId, answers })
  })
}
